import type { ContentPage } from "@/lib/content/types";

// MIGRATED (Phase 3): faithful port of the former hand-coded
// app/(homes)/(hrms)/hrms-software/payroll-management-system/custom-deductions/page.jsx onto the content
// engine (template "hrmsFeature"). Copy, images, links and heading levels
// match the original. SEO still comes from GeneralPageSEOMetadata.json via
// <SEO> (its "custom-deductions" entry is kept); the seo block below is a fallback.

export const customDeductions: ContentPage = {
  slug: "payroll-management-system/custom-deductions",
  template: "hrmsFeature",
  seo: {
    title: "Efficient Management of Custom Payroll Deductions",
    description: "Configure custom deductions for benefits, taxes, and more, ensuring precise payroll processing tailored to your business and compliance needs.",
    keywords: [
      "custom deductions",
      "payroll deductions management",
      "employee tax deductions",
      "payroll benefits deduction",
      "automated payroll deductions.",
    ],
    ogImage: "/assets/data/seoimages/custom-deductions.webp",
  },
  leaf: {
    hero: {
      caption: "Custom Deductions",
      title: "Customize Deductions to Fit Your Business Needs",
      description: "Tailor deductions for taxes, benefits, and other payroll elements to match your company policies and employee agreements.",
      h1: "caption",
    },
    split: {
      title: "Flexible Deduction Management",
      bullets: [
        { title: "Benefits Deduction Automation", description: "Automate health and retirement deductions easily." },
        { title: "Custom Tax Settings", description: "Adjust tax withholdings for all employee groups." },
        { title: "Union Fee Management", description: "Easily manage union fees and other deductions." },
        { title: "Flexible Deduction Setup", description: "Create custom setups for various deduction types." },
      ],
      image: "/assets/images/img/product/hrms/payrollms/custom-deductions_info.webp",
      imageAlt: "custom-deductions_info",
    },
    cardsHeading: {
      title: "Key Features of Payroll Management System",
      description: "Optimize Payroll management with advanced features designed to streamline tracking, automation, and customization.",
    },
    cards: [
      {
        title: "Payslip Generation",
        href: "/hrms-software/payroll-management-system/payslip-generation",
        description: "Provide clear and detailed payslips automatically each payroll cycle, enhancing transparency and trust with your employees.",
        image: "/assets/images/img/product/hrms/payrollms/payslip-generation_image.webp",
        imageAlt: "payslip-generation",
      },
      {
        title: "Tax and Compliance Management",
        href: "/hrms-software/payroll-management-system/tax-and-compliance-management",
        description: "Manage your payroll taxes and regulatory compliance effortlessly with our comprehensive tax management system.",
        image: "/assets/images/img/product/hrms/payrollms/tax-and-compliance-management_imge.webp",
        imageAlt: "tax-and-compliance-management",
      },
      {
        title: "Overtime and Leave Calculations",
        href: "/hrms-software/payroll-management-system/overtime-leave-calculations",
        description: "Streamline how you handle overtime pay and leave deductions, ensuring fairness and compliance in your payroll processes.",
        image: "/assets/images/img/product/hrms/payrollms/overtime-leave-calculations.webp",
        imageAlt: "overtime-leave-calculations",
      },
      {
        title: "Automated Salary Calculation",
        href: "/hrms-software/payroll-management-system/automated-salary-calculation",
        description: "Simplify and expedite salary calculations with automated systems that integrate attendance and performance data, ensuring precise and timely payroll management.",
        image: "/assets/images/img/product/hrms/payrollms/automated-salary-calculation_image.webp",
        imageAlt: "automated-salary-calculation",
      },
    ],
    testimonials: {
      title: "200+ Businesses across India love & trust us!",
      description: "Know why Superworks is the best HR software in India",
    },
    bookDemoTitle: "Customize Your Payroll Deductions Now!",
    relatedBlogsKeyword: "why-automate-payroll,features-to-look-in-payroll,getbiz-payroll-review",
    metaKey: "custom-deductions",
  },
  sections: [],
};
